module.exports = __webpack_public_path__ + "media/images/frontend/banner_500x220_3-c49d24e1964881187e5e3cd275d63da0.png";